import { render } from "./FormPost.vue?vue&type=template&id=c8dabe70"
import script from "./FormPost.vue?vue&type=script&lang=js"
export * from "./FormPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__